import React, { Component, Fragment } from 'react';
import Wrapper from './../../../../common/component/Wrapper';
import {
    getTitleTable, formatMoney, columnsTable,
    getDataSource, genaratePaginateFilterSort,
    getPermissionActions
} from '../../../../../../helpers/functions';
import { parseListRequestParams } from '../../../../../../utils/commonUtils';

import SaleReport from '../../../../../../models/SaleReport';
import DEFINE, { DATE_TIME_FORMAT, ORDER } from '../../../../../../constants/Define';
import { FormWrapperItem, ListComponent, DatePickerComponent } from '../../../../common/component/Index';
import Button, { ButtonGroup } from '../../../../common/component/Button';
import { Skeleton } from 'antd';
import { omit } from 'lodash';
import moment from 'moment';
import './ReportList.less';

let permisionActions = [];
const defaultState = {

};

const ReportListCols = ['createdDate', 'revenue', 'orderCount', 'voucherOrders', 'tourOrders', 'flightOrders', 'hotelOrders', 'vinWonderOrders'];
const CURRENT_DATE_RANGE_ENUM = {
    DATE: [moment.utc().startOf('days'), moment.utc().endOf('days')],
    WEEK: [moment.utc().startOf('isoWeeks'), moment.utc().endOf('days')],
    MONTH: [moment.utc().startOf('months'), moment.utc().endOf('days')],
}
export default class ReportList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            titleItemTable: getTitleTable(ReportListCols, [], []),
            modelItem: ReportListCols,
            componentTable: {
                createdDate: {
                    render: (text, record) => record.createdDate && record.createdDate.format(DATE_TIME_FORMAT.SHORT_DATE),
                    sorter: (i, k) => i.createdDate.length - k.length,
                    key: 'createdDate',
                },
                revenue: {
                    render: (text, record) => formatMoney(record.revenue || '') + this.props.t('currencySymbol'),
                    sorter: (i, k) => i.revenue.length - k.length,
                    key: 'revenue',
                    align: 'right',
                },
                orderCount: {
                    sorter: (i, k) => i.orderCount.length - k.length,
                    key: 'orderCount',
                    align: 'right',
                },
                voucherOrders: {
                    sorter: (i, k) => i.voucherOrders.length - k.length,
                    key: 'voucherOrders',
                    align: 'right',
                },
                tourOrders: {
                    sorter: (i, k) => i.tourOrders.length - k.length,
                    key: 'tourOrders',
                    align: 'right',
                },
                flightOrders: {
                    sorter: (i, k) => i.flightOrders.length - k.length,
                    key: 'flightOrders',
                    align: 'right',
                },
                hotelOrders: {
                    sorter: (i, k) => i.hotelOrders.length - k.length,
                    key: 'hotelOrders',
                    align: 'right',
                },
                vinWonderOrders: {
                    sorter: (i, k) => i.vinWonderOrders.length - k.length,
                    key: 'vinWonderOrders',
                    align: 'right',
                },
            },
        };
    }

    componentDidMount() {
        permisionActions = getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.ORDER);
    }

    render() {
        const { t, report, downloading } = this.props;
        const { saleReportItems } = report;

        return (
            <Wrapper className="col-md-12 p-0 mt-3 report-list">
                <Wrapper className="col-md-12 row m-0 p-0 report-list-title align-items-end">
                    <h3 className={`col-md-2 ml-0 p-0`}>{t('item.report.revenue')}</h3>
                    <Wrapper className={`col-md-6 m-0 p-0 pr-2 button-section`}>
                        { permisionActions && permisionActions.allowExportExcludeUserInfo &&
                        <Button type="primary" onClick={() => this.onExportExcel(true)}
                            icon="download" loading={downloading}
                            disabled={!(saleReportItems.items && saleReportItems.items.length)}
                            className="mr-2">{t(`item.report.exportExcelExcludeUser`)}</Button>
                        }
                        { permisionActions && permisionActions.allowExportFileExcel &&
                        <Button type="primary" onClick={() => this.onExportExcel(false)}
                            icon="download" loading={downloading}
                            disabled={!(saleReportItems.items && saleReportItems.items.length)}
                            className="mr-2">{t(`item.report.exportExcel`)}</Button>
                        }
                    </Wrapper>
                    <Wrapper className={`align-items-end col-md-4 d-flex flex-column m-0 p-0`}>
                        <ButtonGroup>
                            <Button type="dashed" onClick={() => this.onSelectDateRange({ fullValue: CURRENT_DATE_RANGE_ENUM.DATE })}>{t(`item.report.currentDate`)}</Button>
                            <Button type="dashed" onClick={() => this.onSelectDateRange({ fullValue: CURRENT_DATE_RANGE_ENUM.WEEK })}>{t(`item.report.currentWeek`)}</Button>
                            <Button type="dashed" onClick={() => this.onSelectDateRange({ fullValue: CURRENT_DATE_RANGE_ENUM.MONTH })}>{t(`item.report.currentMonth`)}</Button>
                        </ButtonGroup>
                        <DatePickerComponent className={`form-control applyDates w100-percent mt-1`}
                            hmsComponent={`RangePicker`} format={DATE_TIME_FORMAT.SHORT_DATE}
                            style={{ padding: 0, border: 0 }}
                            onChange={this.onSelectDateRange} name={`applyDates`}
                            placeholder={[t('placeHolderForm.startDate'), t('placeHolderForm.endDate')]}
                            value={[saleReportItems.startDate, saleReportItems.endDate]}
                        />
                    </Wrapper>
                </Wrapper>
                {this.renderList()}
            </Wrapper>
        );
    }

    renderList() {
        const { report, loading } = this.props;
        const { saleReportItems } = report;
        const filters = omit(saleReportItems, 'items')
        const { titleItemTable, modelItem, componentTable } = this.state;

        return (
            <Wrapper className={`mt-2`}>
                <ListComponent
                    tableKey="sale-report-list"
                    classParent="m-0 p-0 sale-report-list"
                    marginTop={'0'} marginBottom={'0'}
                    loading={{ spinning: loading, size: 'large' }}
                    rowKey={(record, k) => record.createdDate ? record.createdDate.format(DATE_TIME_FORMAT.SHORT_DATE) : k}
                    dataSource={getDataSource(saleReportItems.items || [], modelItem)}
                    columns={columnsTable({
                        titleTable: titleItemTable,
                        component: componentTable,
                        itemName: 'report'
                    })}
                    pagination={{ total: filters.totalCount, totalPage: filters.totalPage, current: filters.pageIndex, pageSize: filters.pageSize }}
                    onChange={this.onTableChange}
                    componentTableList={{}}
                />
            </Wrapper>
        )
    }

    onSelectDateRange = (data) => {
        const filters = this.getCurrentFilters()
        filters.pageIndex = 1;
        filters.startDate = data.fullValue[0];
        filters.endDate = data.fullValue[1];
        return this.props.onChangeFilters(filters);
    }

    onTableChange = (pagination, filters, sorter) => {
        const currentFilters = this.getCurrentFilters();
        filters = omit({ ...currentFilters, ...filters }, ['pageSize', 'pageIndex']);
        let newFilters = genaratePaginateFilterSort(pagination, filters, sorter);
        this.props.onChangeFilters(newFilters);
    };

    onChangeFilters = (fieldName, value) => {
        const filters = this.getCurrentFilters()
        filters[fieldName] = value;
        return this.props.onChangeFilters(filters)
    }

    onExportExcel = (isExcludeUserInfo = false) => {
        const filters = this.getCurrentFilters();
        filters.paymentStatus = ORDER.STATUS.PAID;
        filters.pageIndex = undefined;
        filters.pageSize = undefined;
        filters.isExcludeUserInfo = isExcludeUserInfo;
        return this.props.onExportExcel(parseListRequestParams(filters));
    }

    getCurrentFilters() {
        const { report } = this.props;
        const { saleReportItems } = report;
        return omit(saleReportItems, ['items', 'totalCount', 'totalPage']);
    }

}

ReportList.defaultProps = {
    report: new SaleReport(),
    loading: false,
    downloading: false,
    onChangeFilters: filters => { },
    onExportExcel: filters => { },
}

